export default __webpack_public_path__ + "static/media/email-parser-black.c5c11c56.png";